import React from 'react';

export const ParticipantRowList: React.FC<React.ComponentProps<'div'>> = ({
    children,
    ...props
}) => (
    // biome-ignore lint/a11y/useSemanticElements: keep existing semantics but mark as list for screen readers
    <div role="list" {...props}>
        {children}
    </div>
);

export const ParticipantRowListItem: React.FC<React.ComponentProps<'div'>> = ({
    children,
    ...props
}) => (
    // biome-ignore lint/a11y/useSemanticElements: keep existing semantics but mark as listitem for screen readers
    <div role="listitem" {...props}>
        {children}
    </div>
);
